import Button from '@/components/atoms/Button/button';
import LogoWithTextIcon from '@/components/icons/logo-with-text.icon';
import useTranslation from '@/hooks/useTranslation';
import { retryBuildRecovery } from '@/utils/buildRecovery';

export function UpdateRequired() {
  const t = useTranslation('common');

  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-settings p-6 text-center text-white"
      role="alert"
    >
      <LogoWithTextIcon width={200} height="auto" />
      <h1 className="text-3xl font-normal">{t('update-required.title')}</h1>
      <p className="max-w-xl text-lg">{t('update-required.message')}</p>
      <p className="max-w-xl">{t('update-required.help')}</p>
      <Button
        label={t('update-required.action')}
        onClick={retryBuildRecovery}
        primary
      />
    </main>
  );
}
